import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { User } from '../models/user.model';
import { Subject } from "rxjs";

@Injectable()

export class AuthService {

    private userSubject: BehaviorSubject<User>;
    public user: Observable<User>;


    private emailSend = new Subject<any>();
    child1$ = this.emailSend.asObservable();


    SendToChild1(msg: string) {
        this.emailSend.next(msg);
    }

    url: any = environment.API_URL;

    constructor(
        private http: HttpClient
    ) { }

    public get currentUserValue() {
        let data = localStorage.getItem('currentUser');
        let obj: Object = {};
        if (data !== 'undefined')
            return JSON.parse(localStorage.getItem('currentUser'));
        return false;
    }


    public get basicAuthentication() {
        let data = {
            userName: '1QXodus#',
            password: 'Xodus@!)#@done'
        }
        return data;
    }

    public get language() {
        let lang = localStorage.getItem('lang');
        console.log('lang', lang);
        if (lang) {
            return lang;
        }
        return false;
    }

    login(user: User) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + btoa(this.basicAuthentication.userName + ':' + this.basicAuthentication.password)
            })
        };
        return this.http.post<any>(this.url + 'auth/login', user, httpOptions);
    }

    reset(data: any) {
        return this.http.post(this.url + 'user/reset-password', data);
    }


    forgetPassword(data: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + btoa(this.basicAuthentication.userName + ':' + this.basicAuthentication.password)
            })
        };
        return this.http.post(this.url + 'auth/forgot-password', data, httpOptions);
    }

    resetPassword(data: any) {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'responseType': 'json',
            accesstoken: data.token,
            'Authorization': 'Basic ' + btoa(this.basicAuthentication.userName + ':' + this.basicAuthentication.password)

        });
        return this.http.post(this.url + 'api/resetPassword', data, { headers: headers });
    }

    logout(data: any) {
        // localStorage.removeItem('currentUser');
        return this.http.post(this.url + 'api/user/logout', data);
    }

    updateuser(data: any) {
        return this.http.patch(this.url + 'user/update', data);
    }

    changePassword(id:any,data: any) {
        return this.http.post(this.url + 'auth/change-password', data);
    }

    emailValidation(data: any) {
        return this.http.post(this.url + "user/emailExists", data);
    }


}